var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"age-group-selectors"},[_vm._l((_vm.ageGroupSpecialtiesRelations),function(ageGroupSpecialtyRelation){return [_c('AgeGroupSelector',{attrs:{"specialty":{
                              id: ageGroupSpecialtyRelation.id,
                              name: ageGroupSpecialtyRelation.name,
                            }},model:{value:(ageGroupSpecialtyRelation.ageGroup),callback:function ($$v) {_vm.$set(ageGroupSpecialtyRelation, "ageGroup", $$v)},expression:"ageGroupSpecialtyRelation.ageGroup"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }